import { render, staticRenderFns } from "./case-info.vue?vue&type=template&id=5971bbc6&scoped=true"
import script from "./case-info.vue?vue&type=script&lang=ts"
export * from "./case-info.vue?vue&type=script&lang=ts"
import style0 from "./case-info.vue?vue&type=style&index=0&id=5971bbc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971bbc6",
  null
  
)

export default component.exports